import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: '/home'
    }, {
      path: '/home',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '山东鑫华技术有限公司',
            description: '山东鑫华技术有限公司是一家专注于冶金矿山、煤炭、化工、电力、能源行业的数字化、网络化、智能化的全产业链解决方案提供商,国家级高新技术企业。'
          }
        }, {
          path: '/product/center',
          name: 'product',
          component: resolve => require(['@/view/product'], resolve),
          meta: {
            title: '产品中心'
          },
        },
        {
          path: '/software',
          name: 'software',
          component: resolve => require(['@/view/software'], resolve),
          meta: {
            title: '产品中心'
          },
          children: [
            {
              path: '/software/smartTown:id',
              name: 'smartTown',
              component: resolve => require(['@/view/Software_smartTown'], resolve),
              meta: {
                title: '产品中心'
              }
            },
            {
              path: '/software/bigData',
              name: 'bigData',
              component: resolve => require(['@/view/Software_bigData'], resolve),
              meta: {
                title: '产品中心'
              }
            }
          ]
        },
        {
          path: '/service',
          name: 'service',
          component: resolve => require(['@/view/Service'], resolve),
          meta: {
            title: '智能化解决方案'
          }
        },
        {
          path: '/Service_left',
          name: 'Service_left',
          component: resolve => require(['@/view/Service_left'], resolve),
          meta: {
            title: '智能化解决方案'
          },
          children: [
            {
              path: '/Service_left/Service_right:id',
              name: 'Service_right',
              component: resolve => require(['@/view/Service_right'], resolve),
              meta: {
                title: '智能化解决方案'
              }
            }
          ]
        },
        {
          path: '/Service_right:id',
          name: 'Service_right',
          component: resolve => require(['@/view/Service_right'], resolve),
          meta: {
            title: '智能化解决方案'
          }
        },
        {
          path: '/product/success',
          name: 'success',
          component: resolve => require(['@/view/product.vue'], resolve),
          meta: {
            title: '成功案例'
          }
        },
        {
          path: '/success_left',
          name: 'success_left',
          component: resolve => require(['@/view/success_left'], resolve),
          meta: {
            title: '成功案例'
          },
          children: [
            {
              path: '/success_left/success_right:id',
              name: 'success_right',
              component: resolve => require(['@/view/success_right'], resolve),
              meta: {
                title: '成功案例'
              }
            }
          ]
        },
        {
          path: '/success_right:id',
          name: 'success_right',
          component: resolve => require(['@/view/success_right'], resolve),
          meta: {
            title: '成功案例'
          }
        },
        {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: '新闻中心'
          }
        },
        {
          path: '/News',
          name: 'News',
          component: resolve => require(['@/view/News'], resolve),
          meta: {
            title: '新闻中心'
          }
        },
        {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: '公司介绍'
          }
        },
        {
          path: '/jobchance',
          name: 'jobchance',
          component: resolve => require(['@/view/JobChance'], resolve),
          meta: {
            title: '工作机会'
          }
        }, {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '联系我们'
          }
        },
        {
          path: '/servicedetail',
          name: 'servicedetail',
          component: resolve => require(['@/view/ServiceDetail'], resolve),
          meta: {
            title: '相关服务'
          }
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  // 设置页面标题
  document.title = (to.meta && to.meta.title) || '山东鑫华技术有限公司'

  // 设置或更新 description meta 标签
  let metaDescription = document.querySelector('meta[name="description"]')
  const descriptionContent = (to.meta && to.meta.description) || '山东鑫华技术有限公司，专注于智慧矿山、国家工信部智能制造制造系统解决方案供应商。'

  if (metaDescription) {
    // 如果已存在 description 标签，直接更新内容
    metaDescription.setAttribute('content', descriptionContent)
  } else {
    // 如果不存在，则创建一个新的 meta 标签
    metaDescription = document.createElement('meta')
    metaDescription.setAttribute('name', 'description')
    metaDescription.setAttribute('content', descriptionContent)
    document.head.appendChild(metaDescription)
  }

  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js